

const table = {
  label: {
    index: "No.",//序号
    account: "Account",//账号
    iccid:"Iccid",//iccid卡号
    imei:'imei',//imei
    whether:'Life free',//是否终身免费
    terminalAccount:"Terminal Account",//终端账号
    terminalName:"Terminal Name",//终端名称
    status: "Status",//状态
    name: "Name",//名称
    yes:"yes",//是
    no:"no",//否
    isOnline: "Online",//在线状态
    balance: "Balance",//余额
    vBalance: "Virtual currency",
    operate: "Operate",//操作
    createTime: "Create Time",//创建时间
    enableTime: "Enable Time",//启用日期
    expiredTime:'Expired Time',
    maturityTime: "Due Time",//到期时间
    OrderMaturityTime:'Order Maturity Time',//订单到期时间
    modifyTime: "Modify Time",//修改时间
    domainName: "Domain Name",//域名

    logEventType:'Type',//日志类型
    functions:'functions',//功能
    operatorAccount:'Operator Account',//操作人账号
    operator:'Operator',//操作人
    origin:'origin',//来源人
    target:'target',//目标人
    beoperated :'Operator',//被操作人
    //operatorRole:'Operator Role',//来源账号
    beoperatedname:'beoperated name',//被操作人名称
    beoperatedAccount:"beoperated Account",//被操作人账号

    operatorRole:'OperatorRole',//操作人角色
    originAccount:'Origin Account',
    originName:'Origin Name',//来源人
    originRole:'Origin Role',//来源角色
    originBalance:'Origin Balance',//来源人余额
    targetName:'Target Name',//目标人
    targetAccount:'Target Account',//目标账号
    targetRole:'Target Role',//目标角色
    targetBalance:'Target Balance',//目标余额
    logInfo:'Log Info',//日志信息

    orderId: 'Order id',
    orderType: 'Order type',
    orderFuncs: 'Order funcs',
    remark: 'remark',
    actNum: 'count',
    pay:'Pay',
    organizationId:'organization Id',//组织id
    organizationName:'Organization Name', //组织名称
    organizationAccount:'Organization Account',//组织账号
    hierarchy:'Hierarchy',
    ChangeTheTargetName:"ChangeTheTargetName",//改签目标名称
    ChangeTheTargetAccount:"ChangeTheTargetAccount",//改签目标名称
    owner:"owner",//所属有者
    operationType:"operationType",//操作类型
    originalOrder:"original order",//原订单号
    used:"Used",//已使用
    Unused:"Unused",//未使用
    beforeTalkie:"改前对讲价格",//改前对讲价格
    afterTalkie:"改后对讲价格",//改后对讲价格
    beforeDispatch:"改前调度价格",//改前调度价格
    afterDispatch:"改后调度价格",//改后调度价格
    beforeRecord:"改前录音存储一个月",//改前录音存储一个月
    afterRecord:"改后录音存储一个月",//改后录音存储一个月
    beforeRecord1:"改前录音存储三个月",//改前录音存储三个月
    afterRecord1:"改后录音存储三个月",//改后录音存储三个月
    beforeRecord2:"改前录音存储六个月",//改前录音存储六个月
    afterRecord2:"改后录音存储六个月",//改后录音存储六个月
    beforeRecord3:"改前录音存储一年",//改前录音存储一年
    afterRecord3:"改后录音存储一年",//改后录音存储一年
    beforeLocation:"改前定位存储7天",//改前定位存储7天
    afterLocation:"改后定位存储7天",//改后定位存储7天
    beforeLocation1:"改前定位存储一个月",//改前定位存储一个月
    afterLocation1:"改后定位存储一个月",//改后定位存储一个月
    beforeLocation2:"改前定位存储三个月",//改前定位存储三个月
    afterLocation2:"改后定位存储三个月",//改后定位存储三个月
    beforeLocation3:"改前定位存储六个月",//改前定位存储六个月
    afterLocation3:"改后定位存储六个月",//改后定位存储六个月
    beforeLocation4:"改前定位存储一年",//改前定位存储一年
    afterLocation4:"改后定位存储一年",//改后定位存储一年
    rebateAccount:"Rebate source account",//返利来源账号
    rebateName:"Rebate source name",//返利来源名称
    rebateAmount:"Rebate amount",//返利金额
    createDate: "Create date",// 创建日期
    transactionAmount:"Transaction amount",//交易金额
    originBeforeBalance:"Origin before balance",//来源人操作前余额
    originAfterBalance:"Origin after balance",//来源人操作后余额
    targetBeforeBalance:"Target before balance",//目标人操作前余额
    targetAfterBalance:"Target after balance",//目标人操作后余额
    paymentDetails:"Payment Details",//订单支付详情






    proxy: {
      name: "Agent Name",//代理名称
      account: "Agent Account",//代理账号
      enterpriseCount: "Company No.",//企业数量
      terminalCount: "Registered User",//注册用户
      useTerminalCount: "Used User",//使用用户
      onlineTerminalCount: "Online User",//在线用户
      lifelongCount: "Lifelong Count", //终身用户
      phone:"Phone", //电话
      company:"Company", //公司
      groupName:"Group Name",//群组名称
      groupId:"Group Id",//群组id
    },
    terminal:{
      id:'Terminal Id',//终端Id
      name: "Terminal Name",//终端名称
      account: "Terminal Account",//终端账号
    },
    enterprise: {
      name: "Company Name",//企业名称
      account: "Company Account",//企业账号
      id: "Company Id"//企业id
    },
    group: {
      name: "Group Name",//群组名称
      type: "Group Type"//群组类型
    },
    subagen:{
      name: "Subagen Name",//代理名称
      account: "Subagen Account",//代理账号
      balance: " Subagen Balance",//余额
    },
  }
};
export default table;



// WEBPACK FOOTER //
// ./src/api/lang/modules/table/table_en.js